import classNames from 'classnames';
import React from 'react';

export type SpinnerProps = {
  tag?: string;
  className?: string;
  size?: 'lg' | 'md' | 'sm';
  type?: 'bordered' | 'grow';
  color?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
};

const Spinner = (props: SpinnerProps) => {
  const { tag = 'div', className, size, type = 'bordered', color = 'secondary', children, style } = props;

  return (
    <div
      style={{
        display: 'inline-flex',
        width: '2rem',
        height: '2rem',
        ...style,
      }}
    >
      <div
        role="status"
        className={classNames(
          {
            'spinner-border': type === 'bordered',
            'spinner-grow': type === 'grow',
          },
          [`text-${color}`],
          { [`avatar-${size}`]: size },
          className
        )}
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Spinner;
